<header *ngIf="dedupeTaskId">
  <h1 mat-dialog-title><i class="DupliKit-KyloeIcon"></i>Review Merges</h1>
  <i class="bhi-times" (click)="dialogRef.close()" [matTooltip]="'Return to all merges.'"></i>
</header>
<div mat-dialog-content class="grid-2 scrollable-container">
  <div class="content">
    <span *ngIf="masterDupePairsLoading; else showTable">
      <i class="input-loading-spinner spinner-border spinner-border-sm"></i>
    </span>
    <ng-template #showTable>
      <table>
        <tr>
          <th></th>
          <th>Master ID</th>
          <th>Duplicate ID</th>
          <th *ngIf="showDetails">Details</th> <!-- TODO: should hide if no details expanded for any -->
        </tr>
        <tr *ngFor="let masterDupePair of masterDupePairs">
          <td>
            <i class="bhi-expand"
               (click)="toggleMergeLogs(masterDupePair.duplicateId)" *ngIf="!mergeLogVisibility[masterDupePair.duplicateId]"></i>
            <i class="bhi-collapse"
               (click)="toggleMergeLogs(masterDupePair.duplicateId)" *ngIf="mergeLogVisibility[masterDupePair.duplicateId]"></i>
          </td>
          <td>{{ masterDupePair.masterId }}</td>
          <td>{{ masterDupePair.duplicateId }}</td>
          <td *ngIf="showDetails">
            <app-association-merges *ngIf="mergeLogVisibility[masterDupePair.duplicateId]"
                                    [masterDupePair]="{'dedupeTaskId': dedupeTaskId, 'masterId': masterDupePair.masterId, 'duplicateId': masterDupePair.duplicateId}">

            </app-association-merges>
          </td>
        </tr>
      </table>
    </ng-template>
  </div>
</div>
